import React from 'react';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {NumericField} from '@views/purchases/fields/materials/NumericField';

export function PriceField(props: IListColumnProps) {
    return <NumericField {...props} step={0.01}/>;
}
